<template>
  <div style="width: 100%; height: 100%">
    <div class="systemBar" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
// var charts = {}
export default {
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chart: {}
    }
  },
  created () {},
  mounted () {
    this.chart = echarts.init(document.querySelector('.systemBar'))
    // 根据浏览器宽度变化改变可视化报表图宽高
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
  },
  methods: {
    updateCharts () {
      const total = this.chartData.reduce((pre, cur) => pre + cur.value, 0)
      this.chart.setOption({
        title: {
          text: `总库存${parseFloat(total).toFixed(3)}吨`,
          left: 'center',
          textStyle: {
            color: '#FFF'
          },
          top: '10%'
        },
        series: [{
          type: 'pie',
          radius: [40, 80],
          top: '20%',
          height: '66%',
          left: 'center',
          width: '80%',
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          label: {
            alignTo: 'edge',
            formatter: '{name|{b}}\n{value|{c} 吨 {d}%}',
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              name: {
                fontSize: 14,
                color: '#fff'
              },
              value: {
                fontSize: 14,
                color: '#fff'
              }
            }
          },
          labelLine: {
            length: 15,
            length2: 0,
            maxSurfaceAngle: 80
          },
          labelLayout: function (params) {
            const isLeft = params.labelRect.x < this.chart && this.chart.getWidth() / 2
            const points = params.labelLinePoints
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width
            return {
              labelLinePoints: points
            }
          },
          data: this.chartData
        }]
      })
    }
  },
  watch: {
    chartData: {
      handler (val) {
        this.updateCharts()
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss"></style>
